export default __webpack_public_path__ + "static/media/ripple4.a34d704e.png";